<template>
    <div>
        <b-navbar toggleable="md" class="header">
            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
            <b-navbar-brand href="/"><img alt="logo" src="../assets/wc_logo.jpg" style="height:50px" /></b-navbar-brand>
            <b-collapse is-nav id="nav_collapse">
            <b-navbar-nav>
                <b-nav-item href="/payments">Payments</b-nav-item>
                <b-nav-item href="/services">Services</b-nav-item>
                <b-nav-item href="/pricing">Pricing</b-nav-item>
                <b-nav-item href="/certifications">Certifications</b-nav-item>
                <b-nav-item href="/services/diy">Services for DIY</b-nav-item>
                <b-nav-item href="/contact">Contact Us</b-nav-item>
                <b-nav-item href="/water_usage">Water Usage</b-nav-item>
            </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
</template>
<script>
    export default {
        name: 'TopMenu',
    };
</script>